import merge from "lodash/merge";
import {
  de as deAdapter,
  enUS as enUSAdapter,
  fr as frAdapter,
  hu as huAdapter,
} from "date-fns/locale";

// date-pickers
import {
  deDE as deDEDate,
  enUS as enUSDate,
  frFR as frFRDate,
} from "@mui/x-date-pickers/locales";
// core
import {
  deDE as deDECore,
  enUS as enUSCore,
  frFR as frFRCore,
} from "@mui/material/locale";
// data-grid
import {
  deDE as deDEDataGrid,
  enUS as enUSDataGrid,
  frFR as frFRDataGrid,
} from "@mui/x-data-grid";

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: "Magyar",
    value: "hu",
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: huAdapter,
    icon: "flagpack:hu",
  },
  {
    label: "English",
    value: "en",
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: "flagpack:gb-nir",
  },
  {
    label: "Français",
    value: "fr",
    systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
    adapterLocale: frAdapter,
    icon: "flagpack:fr",
  },
  {
    label: "Deutsch",
    value: "ger",
    systemValue: merge(deDEDate, deDEDataGrid, deDECore),
    adapterLocale: deAdapter,
    icon: "flagpack:de",
  },
  {
    label: "српски",
    value: "srb",
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: "flagpack:rs",
  },
  {
    label: "ελληνικά",
    value: "gre",
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: "flagpack:gr",
  },
  {
    label: "Βούλγαρος",
    value: "bg",
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: "flagpack:bg",
  },
  // {
  //   label: 'Vietnamese',
  //   value: 'vi',
  //   systemValue: merge(viVNDate, viVNDataGrid, viVNCore),
  //   adapterLocale: viVNAdapter,
  //   icon: 'flagpack:vn',
  // },
  // {
  //   label: 'Chinese',
  //   value: 'cn',
  //   systemValue: merge(zhCNDate, zhCNDataGrid, zhCNCore),
  //   adapterLocale: zhCNAdapter,
  //   icon: 'flagpack:cn',
  // },
  // {
  //   label: 'Arabic',
  //   value: 'ar',
  //   systemValue: merge(arSDDataGrid, arSACore),
  //   adapterLocale: arSAAdapter,
  //   icon: 'flagpack:sa',
  // },
];

export const defaultLang = allLangs[0]; // Hungarian

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
